import { TypographyOptions } from '@mui/material/styles/createTypography';
import { Palette } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import fontsConfig from './fonts';
import paletteConfig, { colors } from './palette';
import breakPoints from './breakpoints';
import { IEBreakPoints } from './@types';

const theme = createTheme({
  breakpoints: {
    values: breakPoints,
  },
});

const fontFamily: string[] = [
  `"${fontsConfig.families.primary}"`,
  `"${fontsConfig.families.primary}"`,
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];

const typography: TypographyOptions | ((palette: Palette) => TypographyOptions) = {
  fontSize: fontsConfig.sizes.default,
  htmlFontSize: fontsConfig.sizes.default,
  fontFamily: fontFamily.join(','),
  allVariants: {
    color: paletteConfig.text?.primary,
  },
  caption: {
    color: colors.eighth.light,
    textAlign: 'center',
    fontSize: fontsConfig.sizes.smallL,
    fontStyle: 'normal',
    fontWeight: fontsConfig.weights.Normal,
    lineHeight: 'normal',
  },
  overline: {
    fontSize: 16,
  },
  h1: {
    fontSize: fontsConfig.sizes.large,
    color: colors.secondary.main,
    fontWeight: fontsConfig.weights.Bold,
  },
  h2: {
    fontSize: fontsConfig.sizes.default,
    color: colors.secondary.main,
    fontWeight: fontsConfig.weights.SemiBold,
    [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
      fontSize: fontsConfig.sizes.medium,
    },
  },
  subtitle1: {
    fontSize: fontsConfig.sizes.medium,
    fontWeight: fontsConfig.weights.Normal,
  },
  subtitle2: {
    fontSize: fontsConfig.sizes.default,
    fontWeight: fontsConfig.weights.SemiBold,
  },
  h6: {
    fontSize: fontsConfig.sizes.mediumL,
    fontWeight: fontsConfig.weights.Bold,
    [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
      fontSize: fontsConfig.sizes.largeL,
    },
  },
  body1: {
    fontSize: fontsConfig.sizes.defaultS,
  },
  body2: {
    fontSize: fontsConfig.sizes.defaultL,
    [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
      fontSize: fontsConfig.sizes.large,
    },
  },
};

export default typography;
